export enum ProfileActionTypes {
  UpdateProfile = 'UpdateProfile',
  ClearProfile = 'ClearProfile',
}
